<template>
  <div class="contract-history-report">
    <el-card class="box-card">

      <el-tabs v-model="activeTab" type="border-card" style="margin-top: 20px;">
        <!-- Tab 1: Contract Movement -->
        <el-tab-pane label="Contract Movement" name="movement">
          <div class="report-section">
            <el-form :inline="true" :model="query" size="medium">
              <el-form-item label="Month">
                <el-select v-model="query.month" placeholder="Month" style="width:100px">
                  <el-option v-for="item in month_option" :key="item.value" :label="item.value" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="Year">
                <el-select v-model="query.year" placeholder="Year" style="width:100px">
                  <el-option v-for="item in year_option" :key="item.value" :label="item.value" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  :loading="loading"
                  @click="queryData()"
                >Query</el-button>
                <el-button
                  type="success"
                  icon="el-icon-download"
                  style="margin-left: 10px"
                  @click="exportMovement()"
                >Export</el-button>
              </el-form-item>
            </el-form>
            <div class="section-header">
              CONTRACT MOVEMENT IN {{ query.month }}-{{ query.year }}
            </div>
            <el-table
              v-loading="loadingMovement"
              :data="movementData"
              border
              show-summary
              :summary-method="getSummary"
              header-cell-class-name="report-header"
              style="width: 100%"
            >
              <el-table-column prop="memberCode" label="Membercode" width="120" align="center" />
              <el-table-column prop="contractUid" label="Contract ID" min-width="200" />
              <el-table-column prop="type" label="Type" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.type === 'monthly' ? 'primary' : 'success'" size="mini">
                    {{ scope.row.type }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="bankholderId" label="BankholderID" width="120" align="center" />
              <el-table-column prop="contractDate" label="Contract Date" width="160" align="center" />
              <el-table-column prop="createInMonth" label="Create in this Month" width="150" align="center">
                <template slot-scope="scope">
                  {{ scope.row.createInMonth ? 'Yes' : 'No' }}
                </template>
              </el-table-column>
              <el-table-column prop="durationMonths" label="Months" width="80" align="center" />
              <el-table-column prop="contractSize" label="Contract Size" width="120" align="right">
                <template slot-scope="scope">
                  {{ scope.row.contractSize | money }}
                </template>
              </el-table-column>
              <el-table-column prop="renewInMonth" label="Renew in this month" width="150" align="center">
                <template slot-scope="scope">
                  {{ scope.row.renewInMonth ? 'Yes' : 'No' }}
                </template>
              </el-table-column>
              <el-table-column prop="creditCount" label="Credit Transactions" width="140" align="center" />
              <el-table-column prop="totalCredit" label="Total Credited" width="120" align="right">
                <template slot-scope="scope">
                  {{ scope.row.totalCredit | money }}
                </template>
              </el-table-column>
              <el-table-column prop="debitCount" label="Debit Transactions" width="140" align="center" />
              <el-table-column prop="totalDebit" label="Total Debited" width="120" align="right">
                <template slot-scope="scope">
                  {{ scope.row.totalDebit | money }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <!-- Tab 2: Contract State -->
        <el-tab-pane label="Contract State" name="state">
          <div class="report-section">
            <el-form :inline="true" :model="query" size="medium">
              <el-form-item label="Status">
                <el-select
                  v-model="query.filter_status"
                  placeholder="State"
                  style="width:120px"
                >
                  <el-option label="Active" value="active" />
                  <el-option label="End" value="completed" />
                  <el-option label="All" value="all" />
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  :loading="loading"
                  @click="getContractStateData()"
                >Query</el-button>
                <el-button type="success" icon="el-icon-download" @click="exportState()">Export</el-button>
              </el-form-item>
            </el-form>
            <div class="section-header">
              CONTRACT STATE
            </div>

            <el-table
              v-loading="loadingState"
              :data="stateData"
              border
              header-cell-class-name="report-header"
              style="width: 100%"
            >
              <el-table-column prop="memberCode" label="Membercode" width="120" align="center" />
              <el-table-column prop="contractUid" label="Contract ID" min-width="200" />
              <el-table-column prop="type" label="Type" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.type === 'monthly' ? 'primary' : 'success'" size="mini">
                    {{ scope.row.type }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="bankholderId" label="BankholderID" width="120" align="center" />
              <el-table-column prop="contractDate" label="Contract Date" width="160" align="center" />
              <el-table-column prop="durationMonths" label="Months" width="80" align="center" />
              <el-table-column prop="contractSize" label="Contract Size" width="120" align="right">
                <template slot-scope="scope">
                  {{ scope.row.contractSize | money }}
                </template>
              </el-table-column>
              <el-table-column prop="currentBalance" label="Current Balance" width="140" align="right">
                <template slot-scope="scope">
                  {{ scope.row.currentBalance | money }}
                </template>
              </el-table-column>
              <el-table-column prop="remainMonths" label="Remain Months" width="130" align="center" />
              <el-table-column prop="lastUpdateDate" label="Last Update Date" width="130" align="center" />
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>

    </el-card>
  </div>
</template>

<script>
import { getContractMovement, getContractMovementExcel, getContractState, getContractStateExcel } from '@/api/report'
import { currentYear, currentMonth, padStart } from '@/utils'

export default {
  name: 'ContractHistoryReport',
  filters: {
    money(val) {
      if (!val && val !== 0) return '0.00'
      return parseFloat(val).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  },
  props: {
    project: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      query: {
        project_uid: this.project,
        month: currentMonth(),
        year: currentYear(),
        filter_status: 'all'
      },
      activeTab: 'movement',
      loading: false,
      loadingMovement: false,
      loadingState: false,
      movementData: [],
      stateData: [],
      month_option: [],
      year_option: [],
      lastUpdateDate: ''
    }
  },
  watch: {
    project(val) {
      this.query.project_uid = val
      this.queryData()
    }
  },
  created() {
    this.dropdownMonthYear()
    if (this.project) {
      this.queryData()
    }
  },
  methods: {
    queryData() {
      this.getContractMovementData()
      this.getContractStateData()
    },
    getSummary(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = ''
          return
        }
        if (column.property === 'creditCount' || column.property === 'totalCredit') {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            if (column.property === 'totalCredit') {
              sums[index] = sums[index].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
          } else {
            sums[index] = ''
          }
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    getContractMovementData() {
      if (!this.query.project_uid) return
      this.loadingMovement = true
      const { month, year, project_uid } = this.query
      getContractMovement({ month, year, project_uid }).then(({ result, data }) => {
        this.loadingMovement = false
        if (result) {
          this.movementData = data || []
        }
      }).catch(() => { this.loadingMovement = false })
    },
    getContractStateData() {
      if (!this.query.project_uid) return
      this.loadingState = true
      const { project_uid, filter_status } = this.query
      getContractState({ project_uid, filter_status }).then(({ result, data }) => {
        this.loadingState = false
        if (result) {
          this.stateData = data || []
          // Determine last update date from max contractDate or current records if API doesn't provide it explicitly
          if (this.stateData.length > 0) {
            const dates = this.stateData.map(d => new Date(d.contractDate)).filter(d => !isNaN(d))
            if (dates.length > 0) {
              const maxDate = new Date(Math.max(...dates))
              this.lastUpdateDate = maxDate.toISOString().replace('T', ' ').substring(0, 19)
            }
          }
        }
      }).catch(() => { this.loadingState = false })
    },
    exportMovement() {
      const { month, year, project_uid } = this.query
      getContractMovementExcel({ month, year, project_uid })
    },
    exportState() {
      const { project_uid, filter_status } = this.query
      getContractStateExcel({ project_uid, filter_status })
    },
    dropdownMonthYear() {
      this.month_option = []
      this.year_option = []
      for (let m = 1; m <= 12; m++) {
        this.month_option.push({ value: padStart(m, 2) })
      }
      for (let y = (currentYear() - 5); y <= currentYear(); y++) {
        this.year_option.push({ value: y.toString() })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.contract-history-report {
  .report-section {
    margin-bottom: 30px;
  }

  .mt-20 {
    margin-top: 20px;
  }

  .section-header {
    padding: 10px 0;
    font-weight: bold;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    font-size: 16px;
  }

  .report-header {
    background-color: #f1f8e9 !important;
    font-weight: bold;
  }

  .table-summary {
    background-color: #f1f8e9;
    padding: 10px 15px;
    border: 1px solid #ebeef5;
    border-top: none;
    display: flex;
    justify-content: flex-end;

    .summary-item {
      .label {
        font-weight: bold;
        margin-right: 10px;
      }

      .value {
        font-weight: bold;
      }
    }
  }
}
</style>
